import { instanceExternal } from './axios'
import { I18N_PLATFORM_MAP } from '@/constants/language'
import i18n from '@/lang'

export const loadDownloadI18n = language => {
  const localCache = window.__locale_code ? window.__locale_code : (window.__locale_code = {})
  if (localCache[language]) {
    return Promise.resolve()
  } else {
    localCache[language] = true
    // live: https://center-api.croin.cloud/
    // alpha: https://center-test1.cloudtest1.club/
    return instanceExternal
      .get('https://center-api.croin.cloud/i18n/download/v2', {
        params: {
          project: 'vt-cp',
          language: I18N_PLATFORM_MAP[language] || 'en',
        },
      })
      .then(res => {
        i18n.mergeLocaleMessage(language, res.data)
      })
      .catch(() => {})
  }
}
